import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import { ActionTree } from 'vuex';
import { MutationTree } from 'vuex';
import { GetterTree } from 'vuex';
import { VuexState, UserInfo, OfficeDetails ,MyVipCardValid} from '@/interfaces/vuexStateInterface';
import NavInfo from '../interfaces/navInfoInterface';
import { getUserInfo } from '@/apis/common';
import virtualTeachingApi from '@/apis/virtualTeachingAndResearchOffice'
import StudentHomeApi from '@/apis/ktpStudentHome'
import router from '@/router';
import courseStore from './course';
import testing from './testing';
import checkIn from './checkIn';
import activityStore from './activity';
import { getMobilexdomain } from '@/utils/utils';
import { clampDisallowedI18nAfterUserFetch } from '@/utils/i18nClamp';

Vue.use(Vuex);

export const getters: GetterTree<VuexState, VuexState> = {
  getNavInfo(state): NavInfo {
    return state.navInfo;
  },
  getUserInfo(state): UserInfo {
    return state.userInfo;
  },
  getOfficeDetails(state): OfficeDetails {
    return state.officeDetails;
  },
  getMyVipCardValid(state): MyVipCardValid {
    return state.vipCardValid;
  },
};

export const mutations: MutationTree<VuexState> = {
  setUserInfo(state, userInfo: UserInfo) {
    state.userInfo = userInfo;
  },
  setNavInfo(state, navInfo: NavInfo) {
    state.navInfo = Object.assign({}, state.navInfo, navInfo);
  },
  clearNavInfo(state) {
    state.navInfo = {};
  },
  setCourseRole(state, role: string) {
    state.courseRole = role;
  },
  SET_OFFICEDETAILS: (state, details: OfficeDetails) => {
    state.officeDetails = details
  },
  SET_VIPCARDVALID: (state, vipCardValid: MyVipCardValid) => {
    state.vipCardValid = vipCardValid
  },
};
export const actions: ActionTree<VuexState, VuexState> = {
  setUserInfo(ctx) {
    return new Promise((resolve, reject) => {
      let secondDomain = getMobilexdomain();
      getUserInfo({ secondDomain: secondDomain })
        .then(res => {
          ctx.commit('setUserInfo', res as UserInfo);
          const u = res as UserInfo & { i18nSwitchEnabled?: number };
          clampDisallowedI18nAfterUserFetch(Number(u.i18nSwitchEnabled) === 1 ? 1 : 0);
          window.dispatchEvent(new Event('setUserSuccessfully'));
          resolve(res);
        })
        .catch(e => {
          reject(e);
          console.log(e);
          router.push('/login');
          try {
            window.sessionStorage.removeItem('token');
            console.log('token error,set user info error');
          } catch (e) {
            console.log(e);
          }
        });
    });
  },
  async setOfficeDetails(context, resourceid: string) {
    await virtualTeachingApi.getOfficeDetails({ resourceid: resourceid }).then((res: any) => {
      context.commit('SET_OFFICEDETAILS', res)
    }).catch((e) => {
      if (e.code == 10403 || e.message.indexOf('当前用户无操作权限') !== -1) {
        window.location.href = `${window.location.origin}/#/teachingAndResearchOffice`
      }
    })
  },
  async setMyVipCardValid(context){
    StudentHomeApi.getMyVipCardValid().then((res:any)=>{
      context.commit('SET_VIPCARDVALID', res)
    }).catch((e)=>{
      console.log(e)
    })
  }
};

const store: StoreOptions<VuexState> = {
  state: {
    userInfo: {
      id: '',
      username: '',
      usertype: '0'
    },
    navInfo: {},
    newCourseId: '',
    courseInfo: {},
    courseEnrollForm: {
      enrollstate: '0',
      auditstate: '0',
      joinlabelid: '',
      formLists: [
        { title: '姓名', selected: '0' },
        { title: '手机', selected: '0' },
        { title: '学号', selected: '0' },
        { title: '工号', selected: '0' },
        { title: '学校', selected: '0' },
        { title: '公司', selected: '0' },
      ]
    },
    courseRole: '0', // 0 学生 1 老师
    officeDetails: {
      audit: {
        joinAuditCount: 0
      },
      body_type: '',
      content_type: '',
      cover_image: '',
      data_items: [],
      description: '',
      me: {
        role: '',
        state: ''
      },
      members: [],
      organizations: [],
      publish: '',
      resourceid: '',
      scope: '',
      team_config: '',
      title: '',
    },
    vipCardValid:{
      time: {
        begin_time: '',
        end_time: '',
        remainDays: 0,
      },
      isValid: 0,
      isFuture: 0,
    }
  },
  actions,
  mutations,
  getters,
  modules: {
    courseStore,
    testing,
    checkIn,
    activityStore
  },
  
};

export default new Vuex.Store(store);
